import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { EventCtrl }                 from './event';
import { EventInvoicesCtrl }         from './event-invoices';
import { EventInvoicesDirective }    from './event-invoices.directive';
import { EventItemTotalsService }    from './event.item-totals.service';
import { EventService }              from './event.service';
import { EventStatusFilter }         from './event.status.filter.ajs';
import { EventStatusPipe }           from './event.status.pipe';
import { EventTimeService }          from './event.time.service.ajs';
import { EventTimesCtrl }            from './event.times';
import { EventTotalsService }        from './event.totals.service';
import { EventsItemsListCtrl }       from './event.items';
import { EventsStates }              from './events.states.ajs';
import { EventsListCtrl }            from './events';
import { EventsOpenCtrl }            from './events.open';
import { EventsUnassignedCtrl }      from './events.unassigned';

angular.module('workshop.events', [])
  .config(EventsStates)
  .controller('eventCtrl', EventCtrl)
  .controller('EventInvoicesCtrl', EventInvoicesCtrl)
  .controller('eventItemsListCtrl', EventsItemsListCtrl)
  .controller('eventListCtrl', EventsListCtrl)
  .controller('OpenEventsCtrl', EventsOpenCtrl)
  .controller('EventTimesCtrl', EventTimesCtrl)
  .controller('UnassignedEventsCtrl', EventsUnassignedCtrl)
  .directive('eventInvoices', EventInvoicesDirective)
  .factory('EventItemTotals', EventItemTotalsService)
  .factory('Event', EventService)
  .factory('EventTotals', EventTotalsService)
  .filter('eventStatus', EventStatusFilter)
  .service('eventStatusPipe',downgradeInjectable(EventStatusPipe))
  .service('eventTimeApi', EventTimeService);